let visitorType;
export const gtmCheckIfExistingCustomer = (isExistingCustomer) => {
  const currentCustomer = isExistingCustomer?.isCurrentCustomer;
  const customerAccountNumber = isExistingCustomer?.billId;
  if (currentCustomer !== undefined) {
    currentCustomer ? (visitorType = "existing") : (visitorType = "new");
    window.dataLayer.push({
      event: "checkVisitorType",
      visitorType: visitorType,
      customerAccountNumber: customerAccountNumber,
    });
  }
};

export const gtmInstallationType = (installType, cost) => {
  window.dataLayer.push({
    event: "Selected Installation",
    installType: `${installType}: ${cost}`,
  });
};

export const gtmPurchase = (props) => {
  const products = [];
  props.list.cartProducts.forEach((product) => {
    product.categories
      .flatMap((product) => product.cartServiceOptions)
      .forEach((option) => {
        if (option.status === "Required") {
          products.push({
            id: option.id,
            name: product.productName,
            serviceCoreTypeName: product.serviceCoreTypeName,
            category: option.category,
            price: option.cost,
            securityDepositAmount: product.securityDepositAmount,
            quantity: 1,
            status: option.status,
          });
        } else if (option.selectedQuantity > option.currentQuantity) {
          products.push({
            id: option.id,
            name: option.serviceOptionName,
            serviceCoreTypeName: product.serviceCoreTypeName,
            category: option.category,
            price: option.cost,
            securityDepositAmount: "Not Applicable",
            quantity: 1,
            status: option.status,
          });
        }
      });
    return products;
  });

  let revenue;

  const singleProductName = (props) => {
    revenue = props.totalMonthlyCharges;
    const filterRequiredProduct = products.filter((product) => product.status === "Required");
    return filterRequiredProduct.map((el) => {
      return el.name;
    });
  };

  const bundleProductName = (props) => {
    revenue = props.newMonthlyCharges;
    return props.bundle.name;
  };

  window.dataLayer.push({
    event: "Purchase",
    planName: props.bundle === null ? singleProductName(props) : bundleProductName(props),
    ecommerce: {
      purchase: {
        actionField: {
          id: props.analyticsTransactionId,
          billId: props.billId,
          revenue,
          monthlyCharges: props.newMonthlyCharges,
          totalMonthlyCharges: props.totalMonthlyCharges,
          taxesAndFeesPaidToday: props.taxesAndFeesPaidToday,
          taxesAndFeesBilled: props.taxesAndFeesBilled,
          federalTax: props.federalTax,
          stateTax: props.stateTax,
          cityTax: props.cityTax,
          bundleSavings: props.bundleSavings,
          oneTimeCharges: props.totalOneTimeCharges,
          isExistingCustomer: props.isCurrentCustomer,
        },
        products,
      },
    },
  });
};
